import React from "react";
import Container from "react-bootstrap/Container";
import Jumbotron from "react-bootstrap/Jumbotron";
import Card from "react-bootstrap/Card";
import L_GLOBALEARN from "../../assets/img/experience/globalearn.png";
import L_PP from "../../assets/img/experience/ParentProtectLogo.png";
import L_YIF from "../../assets/img/experience/YIGLOGOI.png";

import Tilt from "react-tilt";
import "./experience.styles.css";

const Experience = () => {
  return (
    <div id="experience">
      <h1 className="pt-3 text-center font-details-b pb-3">EXPERIENCE</h1>
      <Jumbotron className="jumbo-style">
        {/* </Jumbotron> */}
        {/* SECOND START*/}
        {/* <Jumbotron className="jumbo-style"> */}
          <Container>
            <Tilt options={{ max: 12 }}>
              <Card>
                <Card.Header as="h5" className="d-flex justify-content-center flex-wrap">
                  <Card.Img variant="top" className="img-resize" src={L_PP} alt="GlobalEarn logo" />
                </Card.Header>
                <Card.Body className="d-flex justify-content-center flex-column">
                  <div>
                    <Card.Title className="text-center">MERN Stack Developer Intern</Card.Title>
                  </div>
                  <div>
                    <Card.Text className="text-center style">
                      <strong>Domain:</strong> Web Development.
                      <br />
                      <strong>Role:</strong> MERN Stack Developer Intern.
                      <br />
                      <strong>Description:</strong> 1.Creating RESTful services with Node.js.<br/>
                                                    2.Work in a cross-functional team to deliver a complete user experience.<br/>
                                                    3.Be responsive to change requests and feature requests.<br/>
                                                    4.Writing code that is cross-platform and cross-device compatible.<br />
                      <strong>Technology:</strong> HTML 4,CSS 3,Bootstrap 4 ,Javascript,Node.js ,Express ,React.js,Redux,MongoDB
                      <br />
                      <strong>Duration:</strong> September 2020 - October 2020
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Tilt>
          </Container>
          <br/>
          {/* THIRD START */}
          <Container>
            <Tilt options={{ max: 13 }}>
              <Card>
                <Card.Header as="h5" className="d-flex justify-content-center flex-wrap">
                  <Card.Img variant="top" className="img-resize" src={L_YIF} alt="GlobalEarn logo" />
                </Card.Header>
                <Card.Body className="d-flex justify-content-center flex-column">
                  <div>
                    <Card.Title className="text-center">Lead Web Developer</Card.Title>
                  </div>
                  <div>
                    <Card.Text className="text-center style">
                      <strong>Domain:</strong> Web Development.
                      <br />
                      <strong>Role:</strong> Lead Web Developer.
                      <br />
                      <strong>Description:</strong> 1.Team lead appointed for building an E-Commerce website from scratch.<br/>
                                                    2.Identify user requirements for this project.<br/>
                                                    3.Oversee junior web developers and evaluate their performance.<br/>
                                                    4.Collaborate with mobile developers to make this project cross-platform.<br />
                      <strong>Technology:</strong> HTML 4,CSS 3,Bootstrap 4 ,Javascript,Python,Django,Angular
                      <br />
                      <strong>Duration:</strong> August 2020 - October 2020
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Tilt>
          </Container>
          <br/>
          <Container>
          <Tilt options={{ max: 12 }}>
            <Card>
              <Card.Header as="h5" className="d-flex justify-content-center flex-wrap">
                <Card.Img variant="top" className="img-resize" src={L_GLOBALEARN} alt="GlobalEarn logo" />
              </Card.Header>
              <Card.Body className="d-flex justify-content-center flex-column">
                <div>
                  <Card.Title className="text-center">IT INTERN</Card.Title>
                </div>
                <div>
                  <Card.Text className="text-center style">
                    <strong>Domain:</strong> Front-end Development and Marketing
                    <br />
                    <strong>Role:</strong> Server Management and Social Media Marketing Intern
                    <br />
                    <strong>Description:</strong> 1.Solving real-time problems occuring in website related to UI.<br/>
                    2.Promoting events on social sites on daily basis.
                    <br />
                    <strong>Technology:</strong> HTML 4,CSS 3,Bootstrap 4 ,Javascript and Jquery
                    <br />
                    <strong>Duration:</strong> July 2019 - October 2019
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Tilt>
        </Container>
      </Jumbotron>

      {/* Third END */}
    </div>
  );
};

export default Experience;
